<script lang="ts">
    
    import type { State } from "../../Model/State";
    import { picturesService, playerService } from "../../Services";
    import Picture from "./Picture.svelte";
    import Fa from "svelte-fa";
    import { faPencil } from "@fortawesome/free-solid-svg-icons";
    import type { Game } from "../../Model/Game";
    import { getContext } from "svelte";

    const isRegistered = playerService.isRegistered

    export let pictureId: State<string | null>;
    export let playerName: string = '';
    export let identityOverride: boolean = false;

    let input: HTMLInputElement;
    let uploading = false;

    const game: State<Game | undefined> = getContext('game');

    export function openDialog(): void {
        if (uploading || identityOverride) {
            return;
        }
        input?.click();
    }

    async function onImageChange(): Promise<void> {
        const file = input.files[0];
        input.value = '';

        if (uploading) {
            return;
        }

        uploading = true;

        try {
            if (pictureId.value) {
                await picturesService.deletePicture(pictureId.value);
            }
            pictureId.set(await picturesService.uploadPicture(file));

            if($isRegistered) {
                await playerService.register(playerName, pictureId.value, $game.roomId, $game.id);
            }
        } catch (error) {
            console.error(error);
            pictureId.set(null);
        } finally {
            uploading = false;
        }
        
    }

</script>

<div class="picture-control">
    <input
        type="file"
        accept="image/jpeg,image/png"
        style="display: none;"
        bind:this={input}
        on:change={onImageChange}>
    
    <slot {openDialog}>
        <button type="button" class="open-dialog-btn" on:click={openDialog}>
            {#if $pictureId}
                <Picture id={pictureId} />
            {:else}
                <img class="default-image" src="/images/camera.svg" alt="">
            {/if}
        </button>
    </slot>
    {#if $isRegistered && !identityOverride}
        <button class='edit-selfie' on:click={openDialog}>
            <Fa icon={faPencil} />
        </button>
    {/if}
</div>



<style lang="scss">

    .picture-control {
        position: relative;
        max-width: 160px;
        min-width: 160px;

        &::before {
            content: '';
            display: block;
            padding-top: 100%;
        }

    }

    .open-dialog-btn {
        position: absolute;
        top: 0;
        left: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        font-size: 1rem;
        overflow: hidden;
        border: 3px solid #fff;
    }

    .default-image {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .edit-selfie {
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 0.4rem;
        font-size: 1rem;
    }

</style>

